import { render, staticRenderFns } from "./SPStakingModal.vue?vue&type=template&id=0d7bdd90&scoped=true&"
import script from "./SPStakingModal.vue?vue&type=script&lang=js&"
export * from "./SPStakingModal.vue?vue&type=script&lang=js&"
import style0 from "./SPStakingModal.vue?vue&type=style&index=0&id=0d7bdd90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7bdd90",
  null
  
)

export default component.exports